import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  z-index: 2;
  flex-shrink: 0;

  ${({ isMobile, theme }) =>
    isMobile &&
    css`
      border-left: 1px solid ${theme.colors.gray400};
      padding-left: ${({ theme }) => theme.space.sm};
    `};
`;
